import GroupPermissionsAccordion from './GroupPermissionsAccordion'
export default GroupPermissionsAccordion
